import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["className", "children", "step", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { getWindowWidth } from '../../scripts/helpers';
import IconsHolder from '../icons-holder/IconsHolder';
import parse from 'html-react-parser';
export var stepGraphImg3Width = '230';
export var stepGraphImg3height = '217';
export var stepGraphImg4Width = '200';
export var stepGraphImg4height = '194';
var CollapseContext = createContext({
  toggled: false,
  id: '',
  setToggled: function setToggled() {}
});
function useCollapseContext() {
  var context = useContext(CollapseContext);
  if (!context) {
    throw new Error('Child components of Collapse cannot be rendered outside the Collapse component!');
  }
  return context;
}
export var StepGraphicsWrapper = function StepGraphicsWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children,
    id = _ref.id;
  var idValue = id || 'step-graphics';
  var numberOfCards = React.Children.count(children);
  var cardClassName = "col-lg-".concat(12 / numberOfCards);
  return React.createElement("div", {
    className: "row step-graphics gx-lg-7 ".concat(className || '')
  }, React.Children.map(children, function (child, index) {
    var existingClassName = child.props.className || '';
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        id: "".concat(idValue, "-").concat(index + 1),
        className: "".concat(existingClassName, " ").concat(cardClassName)
      });
    }
    return child;
  }));
};
export var StepGraphics = function StepGraphics(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? 'val' : _ref2$id,
    defaultToggle = _ref2.defaultToggle;
  var _useState = useState(defaultToggle || false),
    _useState2 = _slicedToArray(_useState, 2),
    toggled = _useState2[0],
    setToggled = _useState2[1];
  var value = useMemo(function () {
    return {
      id: id,
      toggled: toggled,
      setToggled: setToggled
    };
  }, [id, toggled, setToggled]);
  return React.createElement(CollapseContext.Provider, {
    value: value
  }, React.createElement("div", {
    className: "expanded-card ".concat(className || '')
  }, React.createElement("div", {
    className: "py-2 py-lg-0 h-100 d-flex flex-column"
  }, React.createElement("div", {
    className: "".concat(toggled ? 'expanded' : '', " px-3 px-lg-0 h-100 d-flex flex-column flex-wrap")
  }, children))));
};
export var StepGraphicsHeading = function StepGraphicsHeading(_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    step = _ref3.step,
    _ref3$as = _ref3.as,
    as = _ref3$as === void 0 ? 'h3' : _ref3$as,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var _useCollapseContext = useCollapseContext(),
    id = _useCollapseContext.id,
    toggled = _useCollapseContext.toggled,
    setToggled = _useCollapseContext.setToggled;
  var _useState3 = useState(getWindowWidth()),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDisabled = _useState6[0],
    setIsDisabled = _useState6[1];
  useEffect(function () {
    var resizeListener = function resizeListener() {
      setWidth(getWindowWidth());
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', resizeListener);
    }
    setIsDisabled(getWindowWidth() > 991);
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', resizeListener);
      }
    };
  }, []);
  useEffect(function () {
    setIsDisabled(width > 991);
  }, [width]);
  return React.createElement(as, {
    className: 'h5 mb-0 w-100'
  }, React.createElement("button", _objectSpread(_objectSpread({
    type: "button"
  }, restProps), {}, {
    disabled: isDisabled,
    className: "".concat(toggled ? '' : 'collapsed', " ").concat(className || '', " btn-reset expanded-button text-secondary"),
    onClick: function onClick(e) {
      if (restProps.onClick) {
        restProps.onClick(e);
      }
      setToggled(!toggled);
    },
    "aria-controls": id,
    "aria-expanded": toggled
  }), step && React.createElement(IconsHolder, {
    className: "me-3 me-lg-0 mb-lg-3",
    step: step,
    variant: "secondary"
  }), React.createElement("span", {
    className: "d-lg-block w-lg-100"
  }, typeof children === 'string' ? parse(children) : children)));
};
export var StepGraphicsBody = function StepGraphicsBody(_ref4) {
  var className = _ref4.className,
    children = _ref4.children;
  var _useCollapseContext2 = useCollapseContext(),
    id = _useCollapseContext2.id,
    toggled = _useCollapseContext2.toggled;
  return React.createElement(Collapse, {
    "in": toggled,
    className: "flex-fill"
  }, React.createElement("div", {
    id: id
  }, React.createElement("div", {
    className: "".concat(className || '', " pb-4 pb-lg-0 d-flex flex-wrap h-100 expandable-body")
  }, typeof children === 'string' ? parse(children) : children)));
};